const styles = theme => {
  return ({
    modal: {
      position: 'fixed !important',
      top: '50% !important',
      left: '50% !important',
      marginLeft: '0 !important',
      transform: 'translate(-50%, -50%) !important',
      translate: 'none !important',
      maxWidth: 'calc(100vw - 32px) !important',
      maxHeight: 'calc(100vh - 32px) !important',
      overflow: 'auto',
      background: 'var(--overlay-background, #fff)',
      color: 'var(--text-color, #222)',
      borderRadius: 'var(--radius-xl, 12px)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
      outline: '1px solid var(--overlay-border, rgba(0, 0, 0, 0.12))',
    },
    root: {
      width: '800px',
      maxWidth: 'calc(100vw - 64px)',
      maxHeight: 'calc(100vh - 96px)',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
    },
    buttons: {
      display: 'flex',
      gap: '8px',
      alignSelf: 'end',
      marginTop: '16px',
    },
    map: {
      width: '100%',
      height: '400px',
      maxHeight: 'calc(100vh - 220px)',
      minHeight: '260px',
    },
    mapUnavailable: {
      alignItems: 'center',
      backgroundColor: '#f5f5f5',
      border: '1px solid #d6d6d6',
      color: '#555',
      display: 'flex',
      height: '400px',
      maxHeight: 'calc(100vh - 220px)',
      minHeight: '260px',
      justifyContent: 'center',
      width: '100%',
    },
  })
}

export default styles
